import { useTranslation } from 'react-i18next';
import type { HistoryProject } from '../hooks/useHistoryTree';
import type { RecencyBucket } from '../utils/grouping';
import { HistoryRow } from './HistoryRow';

export interface HistoryGroupProps {
  readonly bucket: RecencyBucket;
  readonly entries: readonly HistoryProject[];
  readonly onNavigate?: () => void;
}

/** One recency band in the rail — "Today", "Last 7 days" — and its projects. */
export function HistoryGroup({
  bucket,
  entries,
  onNavigate,
}: HistoryGroupProps): React.JSX.Element {
  const { t } = useTranslation();
  const headingId = `history-group-${bucket}`;

  return (
    <section aria-labelledby={headingId} className="pt-5 first:pt-0">
      {/* Sentence case, not the uppercase mono used for data labels elsewhere: a
          band heading is a quiet signpost between rows, and small-caps mono at
          this size reads as a field name for the row beneath it. */}
      <h3 id={headingId} className="dda-section-heading px-2.5 pb-1">
        {t(`assistant.bucket.${bucket}`)}
      </h3>
      <ul className="space-y-0.5">
        {entries.map((entry) => (
          <HistoryRow key={entry.project.id} entry={entry} onNavigate={onNavigate} />
        ))}
      </ul>
    </section>
  );
}
